export default [{
    name: 'comment',
    path: '/comment',
    component: () => import('../views/page/comment.vue'),
    meta: {
      title: '学习评价'
    }
  }, {
    name: 'comment_success',
    path: '/comment_success',
    component: () => import('../views/page/comment_success.vue'),
    meta: {
      title: '学习评价'
    }
  }
]
